const initAnimatedLogo = () => {
  const elsLogo = document.querySelectorAll('.animated-logo');
  if (!elsLogo.length) return;
  const elsVideo = document.querySelectorAll('video.gif-logo');
  const loadVideo = (elVideo) => {
    for (var source in elVideo.children) {
      var videoSource = elVideo.children[source];
      if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
        videoSource.src = videoSource.dataset.src;
      }
    }
    elVideo.load();
  }
  if (elsVideo) {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            videoObserver.unobserve(entry.target);
          }
        })
      })
      elsVideo.forEach(elVideo => {
        videoObserver.observe(elVideo);
      })
    } else {
      elsVideo.forEach(elVideo => {
        loadVideo(elVideo);
      })
    }
  }

  elsLogo.forEach(elLogo => {
    elLogo.addEventListener('mouseenter', () => {
      elLogo.play();
    });
    elLogo.addEventListener('mouseleave', () => {
      elLogo.pause();
      elLogo.currentTime = 0;
    });
  });
}
document.addEventListener("DOMContentLoaded", initAnimatedLogo, false);

var initFeaturedSection = (rootSelector = '#featured-section') => function() {
  var elRoot = document.querySelector(rootSelector);
  if (!elRoot) return;

  var elBtnPrev = elRoot.querySelector('.nav-btns .btn-prev');
  var elBtnNext = elRoot.querySelector('.nav-btns .btn-next');
  var elsLists = [].slice.call(elRoot.querySelectorAll('.cont ul'));

  // Idx from 0
  var maxIdx = elsLists.length - 1;
  var curIdx = 0;

  var fixIdx = function(idx) {
    idx = idx % (maxIdx + 1);
    idx = idx < 0 ? (maxIdx + 1 + idx) : idx;
    return idx;
  }

  var goto = function(idx) {
    var is_first = idx == 0;
    var is_last = idx == maxIdx;

    if (is_first) {
      elBtnPrev.disabled = true;
    } else {
      elBtnPrev.disabled = false;
    }

    if (is_last) {
      elBtnNext.disabled = true;
    } else {
      elBtnNext.disabled = false;
    }

    elsLists.map(function(el, el_idx) {
      if (el_idx == idx) {
        el.className = 'pos-cur';
        if (!el.dataset.manualLazyLoaded) {
          var elLazyImgs = [].slice.call(el.querySelectorAll('img[data-manual-lazy-src]'));
          elLazyImgs.map(function(elLazyImg) {
            elLazyImg.src = elLazyImg.dataset.manualLazySrc;
          });
          el.dataset.manualLazyLoaded = true;
        }
      }
      if (el_idx > idx) {
        el.className = 'pos-next';
      }
      if (el_idx < idx) {
        el.className = 'pos-prev';
      }
    });

    curIdx = idx;
  }

  var next = function(direction) {
    return function() {
      var nextIdx = fixIdx(curIdx + direction);
      goto(nextIdx);
    }
  }

  if (maxIdx > 0) {
    elBtnPrev.addEventListener('click', next(-1));
    elBtnNext.addEventListener('click', next(1));
    goto(0);
  } else {
    elRoot.classList.add('no-nav');
  }

}

document.addEventListener("DOMContentLoaded", initFeaturedSection('#featured-section'), false);
document.addEventListener("DOMContentLoaded", initFeaturedSection('#featured-section-2'), false);


var initMostRencent = function() {
  var elRoot = document.querySelector('#most-rencent');
  if (!elRoot) return;

  var elBtnPrev = elRoot.querySelector('.nav-btns .btn-prev');
  var elBtnNext = elRoot.querySelector('.nav-btns .btn-next');
  var elsLists = [].slice.call(elRoot.querySelectorAll('.cont ul'));

  // Idx from 0
  var maxIdx = elsLists.length - 1;
  var curIdx = 0;

  var fixIdx = function(idx) {
    idx = idx % (maxIdx + 1);
    idx = idx < 0 ? (maxIdx + 1 + idx) : idx;
    return idx;
  }

  var goto = function(idx) {
    var is_first = idx == 0;
    var is_last = idx == maxIdx;

    if (is_first) {
      elBtnPrev.disabled = true;
    } else {
      elBtnPrev.disabled = false;
    }

    if (is_last) {
      elBtnNext.disabled = true;
    } else {
      elBtnNext.disabled = false;
    }

    elsLists.map(function(el, el_idx) {
      if (el_idx == idx) {
        el.className = 'pos-cur';
        if (!el.dataset.manualLazyLoaded) {
          var elLazyImgs = [].slice.call(el.querySelectorAll('img[data-manual-lazy-src]'));
          elLazyImgs.map(function(elLazyImg) {
            elLazyImg.src = elLazyImg.dataset.manualLazySrc;
          });
          el.dataset.manualLazyLoaded = true;
        }
      }
      if (el_idx > idx) {
        el.className = 'pos-next';
      }
      if (el_idx < idx) {
        el.className = 'pos-prev';
      }
    });

    curIdx = idx;
  }

  var next = function(direction) {
    return function() {
      var nextIdx = fixIdx(curIdx + direction);
      goto(nextIdx);
    }
  }

  if (maxIdx > 0) {
    elBtnPrev.addEventListener('click', next(-1));
    elBtnNext.addEventListener('click', next(1));
    goto(0);
  } else {
    elRoot.classList.add('no-nav');
  }

}

document.addEventListener("DOMContentLoaded", initMostRencent, false);


var initCoverStoriesSlider = function() {
  var elRoot = document.querySelector('#cover-stories-slider');
  if (!elRoot) return;

  var elBtnPrev = elRoot.querySelector('.nav-btns .btn-prev');
  var elBtnNext = elRoot.querySelector('.nav-btns .btn-next');
  var elCovers = elRoot.querySelector('.covers');
  var elsTextItems = [].slice.call(elRoot.querySelectorAll('.texts-cont li'));
  var elsCoverItems = [].slice.call(elRoot.querySelectorAll('.covers-cont li'));

  // Idx from 0
  var maxIdx = elsCoverItems.length - 1;
  var curIdx = 0;

  var fixIdx = function(idx) {
    idx = idx % (maxIdx + 1);
    idx = idx < 0 ? (maxIdx + 1 + idx) : idx;
    return idx;
  }

  var goto = function(idx) {

    var elTextItemPosPrev,
      elTextItemPosCur,
      elTextItemPosNext,
      elCoverItemPosPrev,
      elCoverItemPos1,
      elCoverItemPos2,
      elCoverItemPos3,
      elCoverItemPosNext = null;

    if (maxIdx >= 0) {
      elTextItemPosCur = elsTextItems[fixIdx(idx)];
      elCoverItemPos1 = elsCoverItems[fixIdx(idx)];
    }

    if (maxIdx >= 1) {
      elTextItemPosNext = elsTextItems[fixIdx(idx + 1)];
      elCoverItemPos2 = elsCoverItems[fixIdx(idx + 1)];
    }

    if (maxIdx >= 2) {
      elTextItemPosPrev = elsTextItems[fixIdx(idx - 1)];
      elCoverItemPos3 = elsCoverItems[fixIdx(idx + 2)];
    }

    if (maxIdx >= 3) {
      elCoverItemPosPrev = elsCoverItems[fixIdx(idx - 1)];
    }

    if (maxIdx >= 4) {
      elCoverItemPosNext = elsCoverItems[fixIdx(idx + 3)];
    }

    elsTextItems.concat(elsCoverItems)
      .map(function(el) {
        el.className = '';
      });

    elTextItemPosPrev && (elTextItemPosPrev.className = 'pos-prev');
    elCoverItemPosPrev && (elCoverItemPosPrev.className = 'pos-prev');
    elTextItemPosCur && (elTextItemPosCur.className = 'pos-cur');
    elTextItemPosNext && (elTextItemPosNext.className = 'pos-next');
    elCoverItemPosNext && (elCoverItemPosNext.className = 'pos-next');
    elCoverItemPos1 && (elCoverItemPos1.className = 'pos-1');
    elCoverItemPos2 && (elCoverItemPos2.className = 'pos-2');
    elCoverItemPos3 && (elCoverItemPos3.className = 'pos-3');

    curIdx = idx;
  }

  var next = function(direction) {
    return function() {
      var nextIdx = fixIdx(curIdx + direction);
      goto(nextIdx);
    }
  }

  var gotoPrev = next(-1);
  var gotoNext = next(1);

  elBtnPrev.addEventListener('click', gotoPrev);
  elBtnNext.addEventListener('click', gotoNext);

  // Init swape
  var inTouch = false;
  var touchId = '';
  var lastPoint = {};
  var touchStarTs = 0;
  var sumDiffX = 0;
  var maxTs = 500;
  var minDiffRatio = .1;

  elCovers.addEventListener('touchstart', function(evt) {
    if (evt.touches.length >= 2) {
      inTouch = false;
    } else {
      touchId = evt.touches[0].identifier;
      inTouch = true;
      lastPoint = evt.touches[0];
      touchStarTs = Date.now();
    }
  }, { passive: true })

  elCovers.addEventListener('touchend', function(evt) {
    if (inTouch && evt.touches.length === 0) {
      var diffTs = Date.now() - touchStarTs;
      var coversWidth = elCovers.clientWidth;
      var diffRatioX = Math.abs(sumDiffX / coversWidth);
      if (diffTs < maxTs && diffRatioX > minDiffRatio) {
        if (sumDiffX > 0) {
          gotoPrev();
        } else {
          gotoNext();
        }
      }
      touchId = '';
      sumDiffX = 0;
      inTouch = false;
    }
  }, { passive: true })

  elCovers.addEventListener('touchmove', function(evt) {
    if (inTouch) {
      var point = [].slice.call(evt.touches)
        .filter(function(item) { return item.identifier === touchId })[0];
      var diffX = point.clientX - lastPoint.clientX;
      sumDiffX += diffX;
      lastPoint = point;
    }
  }, { passive: true })

  goto(0);
}

document.addEventListener("DOMContentLoaded", initCoverStoriesSlider, false);


var initHpCalculators = function() {
  var elRoot = document.querySelector('#hp-v2-calculators');
  if (!elRoot) return;


  var elCalList = elRoot.querySelector('.calculator-list');
  var elsCalItems = [].slice.call(elCalList.querySelectorAll('li'));

  var elTabList = elRoot.querySelector('.calculator-tabs');
  var elsTabItems = [].slice.call(elTabList.querySelectorAll('li'));

  // Idx from 0
  var maxIdx = elsTabItems.length - 1;
  var curIdx = 0;

  var fixIdx = function(idx) {
    idx = idx % (maxIdx + 1);
    idx = idx < 0 ? (maxIdx + 1 + idx) : idx;
    return idx;
  }

  var goto = function(idx) {
    var elCalItemPosPrev,
      elCalItemPosCur,
      elCalItemPosNext = null;

    if (maxIdx >= 0) {
      elCalItemPosCur = elsCalItems[fixIdx(idx)];
      var elTabItemPosCur = elsTabItems[fixIdx(idx)];
    }

    if (maxIdx >= 1) {
      elCalItemPosNext = elsCalItems[fixIdx(idx + 1)];
      var elTabItemPosNext = elsTabItems[fixIdx(idx + 1)];
    }

    if (maxIdx >= 2) {
      elCalItemPosPrev = elsCalItems[fixIdx(idx - 1)];
      var elTabItemPosPrev = elsTabItems[fixIdx(idx - 1)];
    }

    elsCalItems.map(function(el) {
      el.className = '';
    });

    elCalItemPosPrev && (elCalItemPosPrev.className = 'pos-prev');
    elCalItemPosCur && (elCalItemPosCur.className = 'pos-cur');
    elCalItemPosNext && (elCalItemPosNext.className = 'pos-next');

    elsTabItems.map(function(elTabItem) {
      elTabItem.classList.remove('pos-prev');
      elTabItem.classList.remove('pos-cur');
      elTabItem.classList.remove('pos-next');
    });

    elTabItemPosPrev && (elTabItemPosPrev.classList.add('pos-prev'));
    elTabItemPosCur && (elTabItemPosCur.classList.add('pos-cur'));
    elTabItemPosNext && (elTabItemPosNext.classList.add('pos-next'));

    elsTabItems.map(function(el, idxLoop) {
      if (idxLoop === idx) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });

    curIdx = idx;
  }

  elsTabItems.map(function(elTab, idx) {

    elTab.addEventListener('click', function() {
      elsTabItems.map(function(elTabLoop, idxLoop) {
        goto(idx);
      });
    });

  });

  goto(0);
}

document.addEventListener("DOMContentLoaded", initHpCalculators, false);



var initMoneyEditors = function() {
  var elRoot = document.querySelector('#money-editors');
  if (!elRoot) return;

  var elBtnPrev = elRoot.querySelector('.nav-btns .btn-prev');
  var elBtnNext = elRoot.querySelector('.nav-btns .btn-next');
  var elsLists = [].slice.call(elRoot.querySelectorAll('.cont ul'));

  // Idx from 0
  var maxIdx = elsLists.length - 1;
  var curIdx = 0;

  var fixIdx = function(idx) {
    idx = idx % (maxIdx + 1);
    idx = idx < 0 ? (maxIdx + 1 + idx) : idx;
    return idx;
  }

  var goto = function(idx) {
    var is_first = idx == 0;
    var is_last = idx == maxIdx;

    if (is_first) {
      elBtnPrev.disabled = true;
    } else {
      elBtnPrev.disabled = false;
    }

    if (is_last) {
      elBtnNext.disabled = true;
    } else {
      elBtnNext.disabled = false;
    }

    elsLists.map(function(el, el_idx) {
      if (el_idx == idx) {
        el.className = 'pos-cur';
        if (!el.dataset.manualLazyLoaded) {
          var elLazyImgs = [].slice.call(el.querySelectorAll('img[data-manual-lazy-src]'));
          elLazyImgs.map(function(elLazyImg) {
            elLazyImg.src = elLazyImg.dataset.manualLazySrc;
          });
          el.dataset.manualLazyLoaded = true;
        }
      }
      if (el_idx > idx) {
        el.className = 'pos-next';
      }
      if (el_idx < idx) {
        el.className = 'pos-prev';
      }
    });

    curIdx = idx;
  }

  var next = function(direction) {
    return function() {
      var nextIdx = fixIdx(curIdx + direction);
      goto(nextIdx);
    }
  }

  if (maxIdx > 0) {
    elBtnPrev.addEventListener('click', next(-1));
    elBtnNext.addEventListener('click', next(1));
    goto(0);
  } else {
    elRoot.classList.add('no-nav');
  }

}

document.addEventListener("DOMContentLoaded", initMoneyEditors, false);

function initSwiper({containerSelector, prevSelector, nextSelector}) {
  if (!Array.from(document.querySelectorAll(containerSelector)).some(p => p.querySelectorAll('.swiper-slide').length > 1)) {
    return;
  }
  function setInner(elInner, length, containerWidth) {
    if (!elInner) {
      return
    }
    elInner.style.width = `${length * containerWidth}px`
    elInner.dataset.slideWidth = containerWidth
    elInner.dataset.length = length
    if (!elInner.dataset.idx) {
      elInner.dataset.idx = 0
    }
  }
  function findParentMatching(el) {
    const potentialParents = Array.from(document.querySelectorAll(containerSelector))
    while (el) {
      el = el.parentElement
      if (potentialParents.indexOf(el) >= 0) {
        return el
      }
    }
    return null
  }
  function desktopView() {
    for (const elContainer of Array.from(document.querySelectorAll(containerSelector))) {
      const elSlides = Array.from(elContainer.querySelectorAll('.swiper-slide'))
      const containerWidth = elContainer.closest('.best-of-container').clientWidth / 2
      if (elContainer.querySelector('.swiper-container')) {
        setInner(elContainer.querySelector('.swiper-container-inner'), elSlides.length, containerWidth)
        continue
      }
      const elInner = document.createElement('div')
      elInner.classList.add('swiper-container-inner')
      setInner(elInner, elSlides.length, containerWidth)
      for (const elSlide of elSlides) {
        elInner.append(elSlide.cloneNode(true))
        elSlide.remove()
      }
      const elSwiperContainer = document.createElement('div')
      elSwiperContainer.classList.add('swiper-container')
      elSwiperContainer.append(elInner)
      if (elSlides.length > 1) {
        const elNavigation = document.createElement('div')
        elNavigation.classList.add('swiper-navigation')
        elNavigation.innerHTML = Array.from({length: elSlides.length}).map((_, idx) => `<div class="dot${idx === 0? ' active': ''}"></div>`).join('')
        elSwiperContainer.append(elNavigation)
      }
      elContainer.append(elSwiperContainer)
      setNavBtnStates(elContainer)
    }
  }
  function mobileView() {
    for (const elContainer of Array.from(document.querySelectorAll(containerSelector))) {
      if (!elContainer.querySelector('.swiper-container')) {
        continue
      }
      const elSlides = Array.from(elContainer.querySelectorAll('.swiper-slide')).map(p => p.cloneNode(true))
      elContainer.querySelector('.swiper-container').remove()
      elSlides.forEach(p => elContainer.append(p))
    }
  }
  function init() {
    if (window.innerWidth <= 768) {
      mobileView()
    } else {
      desktopView()
    }
  }
  window.addEventListener('resize', init)
  document.addEventListener("DOMContentLoaded", init, false)

  function setNavBtnStates(elContainer) {
    if (!elContainer) {
      return
    }
    const elInner = elContainer.querySelector('.swiper-container-inner')
    const elPrev = elContainer.querySelector(prevSelector)
    const elNext = elContainer.querySelector(nextSelector)
    if (!(elInner && elPrev && elNext)) {
      return
    }
    let {length, idx} = elInner.dataset
    length = Number.parseInt(length)
    idx = Number.parseInt(idx)
    if (idx === 0) {
      elPrev.setAttribute('disabled', '')
      if (length > 1) {
        elNext.removeAttribute('disabled')
      } else {
        elNext.setAttribute('disabled', '')
      }
      return
    }
    if (idx === length - 1) {
      elNext.setAttribute('disabled', '')
      if (length > 1) {
        elPrev.removeAttribute('disabled')
      } else {
        elPrev.setAttribute('disabled', '')
      }
    }
  }
  function onClickPrev() {
    if (window.innerWidth <= 768) {
      return
    }
    const elBtn = this
    const elContainer = findParentMatching(elBtn)
    if (!elContainer) {
      return
    }
    const elInner = elContainer.querySelector('.swiper-container-inner')
    if (!elInner) {
      return
    }
    let {slideWidth, length, idx} = elInner.dataset
    slideWidth = Number.parseFloat(slideWidth)
    length = Number.parseInt(length)
    idx = Number.parseInt(idx)
    if (idx === 0) {
      return
    }
    const newIdx = idx - 1
    const newLeft = -1 * newIdx * slideWidth
    elInner.style.left = `${newLeft}px`
    elInner.dataset.idx = newIdx
    Array.from(elContainer.querySelectorAll('.swiper-navigation .dot')).forEach(function(el, idx) {
      if (newIdx === idx) {
        el.classList.add('active')
      } else {
        el.classList.remove('active')
      }
    })
    setNavBtnStates(elContainer)
  }
  Array.from(document.querySelectorAll(prevSelector)).forEach(elPrev => elPrev.addEventListener('click', onClickPrev))
  function onClickNext() {
    if (window.innerWidth <= 768) {
      return
    }
    const elBtn = this
    const elContainer = findParentMatching(elBtn)
    if (!elContainer) {
      return
    }
    const elInner = elContainer.querySelector('.swiper-container-inner')
    if (!elInner) {
      return
    }
    let {slideWidth, length, idx} = elInner.dataset
    slideWidth = Number.parseFloat(slideWidth)
    length = Number.parseInt(length)
    idx = Number.parseInt(idx)
    if (idx >= length - 1) {
      return
    }
    const newIdx = idx + 1
    const newLeft = -1 * newIdx * slideWidth
    elInner.style.left = `${newLeft}px`
    elInner.dataset.idx = newIdx
    Array.from(elContainer.querySelectorAll('.swiper-navigation .dot')).forEach(function(el, idx) {
      if (newIdx === idx) {
        el.classList.add('active')
      } else {
        el.classList.remove('active')
      }
    })
    setNavBtnStates(elContainer)
  }
  Array.from(document.querySelectorAll(nextSelector)).forEach(elNext => elNext.addEventListener('click', onClickNext))

  const states = {
    selected: null,
    el: null,
    desktop: {
      pressX: null,
      x: null
    }
  }
  function onMouseDown(e) {
    if (window.innerWidth <= 768) {
      states.selected = 'mobile'
      return
    }
    states.selected = 'desktop'
    states.el = this
    states.desktop.pressX = e.x
    states.desktop.x = e.x

    this.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
  }
  function onMouseMove(e) {
    if (window.innerWidth <= 768) {
      return
    }
    if (states.selected !== 'desktop' || !states.el) {
      return
    }
    states.desktop.x = e.x
    const {x, pressX} = states.desktop
    if (Math.abs(pressX - x) > 3) {
      if (states.el.style.cursor !== 'grabbing') {
        states.el.style.cursor = 'grabbing'
        states.el.style.userSelect = 'none'
      }
    }
  }
  function onMouseUp(e) {
    if (!states.el) {
      return
    }
    states.el.style.cursor = null
    states.el.style.userSelect = ''
    window.removeEventListener('mouseup', onMouseUp)
    states.el.removeEventListener('mousemove', onMouseMove)
    const {pressX, x} = states.desktop
    const width = states.el.clientWidth
    if (Math.abs(pressX - x) / width < 0.15) {
      return
    }
    const goNext = x < pressX
    if (goNext) {
      const elBtnNext = states.el.querySelector(nextSelector)
      if (!elBtnNext) {
        return
      }
      onClickNext.bind(elBtnNext)()
    } else {
      const elBtnPrev = states.el.querySelector(prevSelector)
      if (!elBtnPrev) {
        return
      }
      onClickPrev.bind(elBtnPrev)()
    }
    states.selected = null
    states.el = null
    states.desktop.pressX = null
    states.desktop.x = null
  }
  Array.from(document.querySelectorAll(containerSelector)).forEach(el => el.addEventListener('mousedown', onMouseDown))
}

initSwiper({containerSelector: '.best-of .pins', prevSelector: '.best-of .pins button.btn-prev', nextSelector: '.best-of .pins button.btn-next'})

function initBestOfSection() {
  Array.from(document.querySelectorAll('.best-of .pins .item')).forEach(elPinItem => elPinItem.addEventListener('mousedown', function(e) {
    if (e.target.classList.contains('item-title')) {
      e.stopPropagation()
    }
  }))
  Array.from(document.querySelectorAll('.best-of .pins .item')).forEach(elPinItem => elPinItem.ondragstart = function(e) {
    return false
  })
  const btn_view_more_less = document.querySelector('.best-of .view-more-less')
  btn_view_more_less && btn_view_more_less.addEventListener('click', function() {
    const el = this
    const elPins = document.querySelector('.best-of .pins')
    const isLessMode = el.classList.contains('less')
    if (!isLessMode) {
      // going to expand more
      const {low, high} = measurePinsHeights(elPins)
      elPins.style.height = `${low}px`
      elPins.classList.add('show-all')
      el.classList.add('less')
      setTimeout(() => {
        elPins.style.height = `${high}px`
      }, 0);
      setTimeout(() => {
        elPins.style.height = ''
      }, 500)
    } else {
      // going to collapse
      const {low, high} = measurePinsHeights(elPins)
      elPins.style.height = `${high}px`

      el.classList.remove('less')
      setTimeout(() => {
        elPins.style.height = `${low}px`
      }, 0);
      setTimeout(() => {
        elPins.classList.remove('show-all')
        elPins.style.height = ''
      }, 500)
    }
  })

  function measurePinsHeights(elPins) {
    const expaned = elPins.classList.contains('show-all')
    const pinsHeight = elPins.clientHeight
    const elMeas = elPins.querySelector('.height-measurement')
    elMeas.innerHTML = ''
    Array.from(elPins.querySelectorAll('.swiper-slide')).filter((_, idx) => idx !== 0).forEach(slide => {
      elMeas.append(slide.cloneNode(true))
    })
    const diff = elMeas.scrollHeight
    elMeas.innerHTML = ''
    let low = pinsHeight
    let high = pinsHeight
    if (expaned) {
      low -= diff
    } else {
      high += diff
    }
    // console.log('low_high', {low, high})
    return {
      low, high
    }
  }
}

document.addEventListener("DOMContentLoaded", initBestOfSection, false);

function initTopBanner() {
  document.querySelectorAll('.top-banner .btn-close').forEach(function(el) {
    el.addEventListener('click', function() {
      el.closest('.top-banner').classList.add('collapsed');
      clearInterval(timer);
    });
  });
  if (document.querySelectorAll('.top-banner .banner-body').length < 2) {
    return;
  }
  var delay = Number.parseFloat(document.getElementById('top_banner_delay').value);
  var fadeTimeout = 0.3;
  var timer = setInterval(function() {
    var topEl = document.querySelector('.top-banner .banner-body');
    topEl.classList.remove('fade-in');
    setTimeout(() => {
      document.querySelector('.top-banner').appendChild(topEl);
      topEl = document.querySelector('.top-banner .banner-body');
      setTimeout(() => {
        topEl.classList.add('fade-in');
      }, 10);
    }, fadeTimeout * 1000);
  }, delay * 1000);
}

document.addEventListener("DOMContentLoaded", initTopBanner, false);

function initHomeBanner() {
  var rootEl = document.querySelector('.home-banner');
  var btnEl = rootEl.querySelector('a');
  var encoded_id = getCookie('encoded_id');
  if (encoded_id) {
    btnEl.setAttribute('href', fillUrlParam('encoded_id', encoded_id, btnEl.getAttribute('href')));
  }
  window.addEventListener('signin_changed', function() {
    var encoded_id = getCookie('encoded_id');
    if (encoded_id) {
      btnEl.setAttribute('href', fillUrlParam('encoded_id', encoded_id, btnEl.getAttribute('href')));
    }
  });

  function getCookie(name) {
    var cookieValue = '';
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1).trim());
          break;
        }
      }
    }
    return cookieValue;
  }
  function fillUrlParam(param_name, param_value, url) {
    var reg = new RegExp('&' + param_name + '=([^&]*)');
    if (reg.test(url)) {
      url = url.replace(reg, '&' + param_name + '=' + encodeURIComponent(param_value));
      return url;
    }
    reg = new RegExp('\\?' + param_name + '=([^&]*)');
    if (reg.test(url)) {
      url = url.replace(reg, '?' + param_name + '=' + encodeURIComponent(param_value));
      return url;
    }
    if (url.indexOf('?') === -1) {
      url += '?' + param_name + '=' + param_value;
    } else {
      url += '&' + param_name + '=' + param_value;
    }
    return url;
  }
}

document.addEventListener("DOMContentLoaded", initHomeBanner, false);